import { z } from 'zod';
import { columnRefSchema } from '~/hooks/queries/useAnalyticsStatsViewsQuery';

export const staffReportTemplateSchema = z.object({
  publicId: z.string(),
  statKey: z.string(),
  name: z.string(),
  description: z.string().nullable().optional(),
  selection: z.object({
    columnLayout: z.array(columnRefSchema).nullable(),
  }),
  filters: z.unknown().nullable().optional(),
  sort: z.unknown().nullable().optional(),
  createdAt: z.string(),
  createdBy: z.string(),
  updatedAt: z.string().optional(),
  updatedBy: z.string().nullable().optional(),
  viewType: z.literal('custom').optional(),
  isTemplate: z.boolean().optional(),
});

/** Parses `{ templates: [...] }` from the staff library endpoint (also accepts a bare array). */
export function parseStaffReportTemplatesList(
  data: unknown,
): z.infer<typeof staffReportTemplateSchema>[] {
  if (Array.isArray(data)) {
    return z.array(staffReportTemplateSchema).parse(data);
  }
  return z.object({ templates: z.array(staffReportTemplateSchema) }).parse(data).templates;
}
